/* tslint:disable */
/* eslint-disable */
/**
 * JET Charge Illuminate Web API
 * JET Charge Illuminate Web API
 *
 * The version of the OpenAPI document: 1.0.0
 * Contact: rd@jetcharge.com.au
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from "../runtime";
/**
 *
 * @export
 * @interface GetDisplayedPriceTask
 */
export interface GetDisplayedPriceTask {
    /**
     *
     * @type {boolean}
     * @memberof GetDisplayedPriceTask
     */
    forceRefresh?: boolean;
}

/**
 * Check if a given object implements the GetDisplayedPriceTask interface.
 */
export function instanceOfGetDisplayedPriceTask(
    value: object,
): value is GetDisplayedPriceTask {
    return true;
}

export function GetDisplayedPriceTaskFromJSON(
    json: any,
): GetDisplayedPriceTask {
    return GetDisplayedPriceTaskFromJSONTyped(json, false);
}

export function GetDisplayedPriceTaskFromJSONTyped(
    json: any,
    ignoreDiscriminator: boolean,
): GetDisplayedPriceTask {
    if (json == null) {
        return json;
    }
    return {
        forceRefresh:
            json["forceRefresh"] == null ? undefined : json["forceRefresh"],
    };
}

export function GetDisplayedPriceTaskToJSON(
    value?: GetDisplayedPriceTask | null,
): any {
    if (value == null) {
        return value;
    }
    return {
        forceRefresh: value["forceRefresh"],
    };
}
